<template>
  <v-app>
    <v-container fluid fill-height>
      <v-row class="text-center" justify="center" align-content="center">
        <v-col cols="12" sm="6" justify="center">
          <v-img
            :src="require('../assets/logo.png')"
            class="my-3"
            contain
            height="80"
          />
          <p class="display-5 mb-1">
            <strong>Hitonobiからログアウトします。</strong>
          </p>
          <br />
          <p class="display-5 mb-1">
            ログアウトすると、保存したログイン情報が削除されます。
          </p>
          <p class="display-5 mb-1">
            ログイン情報を削除したくない場合は、そのままブラウザを閉じてください。
          </p>
          <br />
          <div class="text-center">
            <v-btn class="ma-2" outlined color="primary" @click="loginBack"
              >ログイン画面に戻る</v-btn
            >
          </div>
          <br />
          <br />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { delSessionStorageItem, deleteLoginCookie } from '../common.js';
export default {
  created() {
    delSessionStorageItem();
    // Cookieを削除し、ログイン画面に戻る
    deleteLoginCookie();
    this.$router.push({ name: 'Login' });
  },
  methods: {
    loginBack: function () {
      // Cookieを削除し、ログイン画面に戻る
      deleteLoginCookie();
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>
